// extracted by mini-css-extract-plugin
export default {"ResizeHandleInner":"ResizeHandle_ResizeHandleInner__pjTjF","ResizeHandleOuter":"ResizeHandle_ResizeHandleOuter__Wbf2J","Icon":"ResizeHandle_Icon__jaabS"};